import React, { useContext } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";
import "primeflex/primeflex.css";
import "./assets/fonts/fonts.css";
import SignIn from "./pages/Signin";
import Admin from "./Components/Admin";
import User from "./Components/User";
import { AuthContext } from "./AuthContext/AuthContext";
import FormFillPage from "./pages/GenerateForms/FormFillPage";
import ExcelForm from "./pages/ExcelForm/ExcelForm";
import UserCreatedFormFillPage from "./pages/UserSpace/UserCreatedFormFillPage";
function App() {
  const { isAuthenticated, user } = useContext(AuthContext);

  return (
    <div>
      {!isAuthenticated ? (
        <Routes>
          <Route path="/signin" element={<SignIn />} />
          <Route path="/" element={<SignIn />} />
          <Route path="/form/:formId" element={<FormFillPage />} />
          <Route path="/form-excel/:id" element={<ExcelForm />} />
          <Route
            path="/User-Created-Form-Fill/:formId"
            element={<UserCreatedFormFillPage />}
          />
          <Route path="*" element={<SignIn />} />
        </Routes>
      ) : (
        <>
          {user.roles.some((role) => role.name === "ROLE_ADMIN") && <Admin />}
          {user.roles.some((role) => role.name === "ROLE_USER") && <User />}
          {user.roles.some((role) => role.name === "ROLE_SUPERUSER") && (
            <User />
          )}
        </>
      )}
    </div>
  );
}

export default App;
